import { type HttpClient } from '../useHttpClient';

export const patchMuteUser =
  (httpClient: HttpClient) =>
  async (channelUrl: string, userId: string, muted: boolean) => {
    await httpClient.api(
      `/sendbird/channels/${channelUrl}/users/${userId}/mute`,
      {
        method: 'PATCH',
        body: JSON.stringify({ muted }),
      }
    );
  };
